
import { getLatestTemperatureHumidity } from '../../../api/eastCoastDataApi/ElkQuery/IotDataApi.js';

import CONST from '../../../utils/const';
import Utils from '../../../utils/utils';

const state = {
    iotData: [],
    // allIotData: []
    
};

const getters = {
    getIotData: (state)  => {
        return state.iotData;
    },
    
    getScenicIotData: (state) => (scenicAreaId = -1) => { 
        const target = state.iotData.filter(c => c.scenicAreaId === scenicAreaId)
        return target

    }
};

const actions = {


    async getAllIotData({commit},condition){
        // console.log('condition',condition);
        commit('iotEventData',await getLatestTemperatureHumidity(condition));

    }
};

const mutations = {
    iotEventData(state,data){
        if(Utils.isEmptyObject(data)){
            state.iotData = [];
        }
        state.iotData = data;

    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }